<template>
  <div class="view-selector-menu">
    <div class="view-header">
      <div class="view-title">Select View</div>
    </div>
    <div class="menu-divider"></div>
    <div class="view-list">
      <button v-for="view in viewTypes" :key="view.id" class="button menu-button"
        :class="{ active: view.id === selectedViewId }" @click.prevent="handleSelectView(view)">
        <span class="menu-button-label">{{ view.label }}</span>
        <Tooltip v-if="view.tooltip" :text="view.tooltip" position="right">
          <InformationOutlineIcon :size="16" class="info-icon" @click.stop />
        </Tooltip>
      </button>
    </div>
  </div>
</template>

<script>
import InformationOutlineIcon from 'vue-material-design-icons/InformationOutline.vue';
import Tooltip from '../common/Tooltip.vue';

export default {
  name: 'ViewSelectorMenu',
  components: {
    InformationOutlineIcon,
    Tooltip
  },
  props: {
    selectedViewId: {
      type: String,
      required: true
    },
    viewTypes: {
      type: Array,
      required: true,
      validator: (value) => {
        return Array.isArray(value) && value.every(view =>
          view && typeof view.id === 'string' && typeof view.label === 'string'
        );
      }
    }
  },
  methods: {
    handleSelectView(view) {
      this.$emit('select-view', view.id);
    }
  },
  emits: ['select-view']
}
</script>

<style scoped>
.view-selector-menu {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: var(--border-radius);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 220px;
  overflow: hidden;
}

.view-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
}

.view-title {
  font-size: 14px;
  font-weight: 600;
  color: #262626;
}

.menu-divider {
  height: 1px;
  background-color: #f0f0f0;
  margin: 0;
}

.view-list {
  display: flex;
  flex-direction: column;
  max-height: 300px;
  overflow-y: auto;
}

.menu-button {
  width: 100%;
  text-align: left;
  border-radius: var(--border-radius);
  border: none;
  box-shadow: none;
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
}

.menu-button-label {
  display: inline-block;
}

.info-icon {
  color: #999;
  opacity: 0.7;
  transition: opacity 0.2s ease;
  flex-shrink: 0;
}

.menu-button:hover .info-icon {
  opacity: 1;
  color: #666;
}

.menu-button:hover {
  box-shadow: none;
}

.menu-button:active {
  box-shadow: none;
}

.menu-button.active {
  background-color: #e6f4ff;
  color: var(--primary-color);
  font-weight: 500;
  border-color: transparent;
}

.menu-button.active .info-icon {
  color: var(--primary-color);
  opacity: 0.8;
}

.menu-button.active:hover {
  background-color: #e6f4ff;
  border-color: transparent;
}

.menu-button.active::after {
  content: '✓';
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--primary-color);
  font-size: 16px;
}
</style>
